(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 989px)';
  var ROOT_SELECTOR = '[data-lp-benefits-slider]';

  function BenefitsBarSlider(root) {
    if (root.dataset.sliderInitialized === 'true') return;

    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-benefit-slide]'));
    this.mobileQuery = window.matchMedia(MOBILE_QUERY);
    this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.mobileLayout = root.dataset.mobileLayout || 'slider';
    this.autoplay = root.dataset.autoplay === 'true';
    this.autoplaySpeed = Math.max(2000, parseInt(root.dataset.autoplaySpeed, 10) || 4000);
    this.activeIndex = 0;
    this.timer = null;
    this.touchStartX = 0;
    this.touchStartY = 0;

    root.dataset.sliderInitialized = 'true';
    root._benefitsBarSlider = this;

    this.handleMediaChange = this.syncMode.bind(this);
    this.handleReducedMotionChange = this.syncMode.bind(this);
    this.handleVisibilityChange = this.onVisibilityChange.bind(this);
    this.handleTouchStart = this.onTouchStart.bind(this);
    this.handleTouchEnd = this.onTouchEnd.bind(this);
    this.handleMouseEnter = this.stop.bind(this);
    this.handleMouseLeave = this.start.bind(this);
    this.handleFocusIn = this.stop.bind(this);
    this.handleFocusOut = this.start.bind(this);

    if (this.mobileQuery.addEventListener) {
      this.mobileQuery.addEventListener('change', this.handleMediaChange);
      this.reducedMotionQuery.addEventListener('change', this.handleReducedMotionChange);
    } else {
      this.mobileQuery.addListener(this.handleMediaChange);
      this.reducedMotionQuery.addListener(this.handleReducedMotionChange);
    }

    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    root.addEventListener('touchstart', this.handleTouchStart, { passive: true });
    root.addEventListener('touchend', this.handleTouchEnd, { passive: true });
    root.addEventListener('mouseenter', this.handleMouseEnter);
    root.addEventListener('mouseleave', this.handleMouseLeave);
    root.addEventListener('focusin', this.handleFocusIn);
    root.addEventListener('focusout', this.handleFocusOut);

    this.syncMode();
  }

  BenefitsBarSlider.prototype.isSliderMode = function () {
    return this.mobileLayout === 'slider' && this.mobileQuery.matches;
  };

  BenefitsBarSlider.prototype.syncMode = function () {
    var sliderMode = this.isSliderMode();

    this.stop();
    this.root.classList.toggle('is-mobile-slider', sliderMode);

    if (!sliderMode) {
      this.slides.forEach(function (slide) {
        slide.classList.remove('is-active');
        slide.removeAttribute('aria-hidden');
      });
      return;
    }

    this.show(this.activeIndex, false);
    this.start();
  };

  BenefitsBarSlider.prototype.show = function (index, restart) {
    if (!this.slides.length) return;

    this.activeIndex = (index + this.slides.length) % this.slides.length;

    this.slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === this.activeIndex;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    }, this);

    if (restart !== false) {
      this.stop();
      this.start();
    }
  };

  BenefitsBarSlider.prototype.next = function () {
    this.show(this.activeIndex + 1);
  };

  BenefitsBarSlider.prototype.previous = function () {
    this.show(this.activeIndex - 1);
  };

  BenefitsBarSlider.prototype.start = function () {
    var self = this;

    if (
      !this.isSliderMode() ||
      !this.autoplay ||
      this.slides.length < 2 ||
      this.reducedMotionQuery.matches ||
      document.hidden
    ) {
      return;
    }

    this.stop();
    this.timer = window.setInterval(function () {
      self.show(self.activeIndex + 1, false);
    }, this.autoplaySpeed);
  };

  BenefitsBarSlider.prototype.stop = function () {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  };

  BenefitsBarSlider.prototype.onVisibilityChange = function () {
    if (document.hidden) {
      this.stop();
    } else {
      this.start();
    }
  };

  BenefitsBarSlider.prototype.onTouchStart = function (event) {
    if (!this.isSliderMode() || !event.touches.length) return;
    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
    this.stop();
  };

  BenefitsBarSlider.prototype.onTouchEnd = function (event) {
    if (!this.isSliderMode() || !event.changedTouches.length) return;

    var deltaX = event.changedTouches[0].clientX - this.touchStartX;
    var deltaY = event.changedTouches[0].clientY - this.touchStartY;

    if (Math.abs(deltaX) >= 35 && Math.abs(deltaX) > Math.abs(deltaY)) {
      if (deltaX < 0) {
        this.next();
      } else {
        this.previous();
      }
      return;
    }

    this.start();
  };

  BenefitsBarSlider.prototype.selectBlock = function (blockId) {
    if (!this.isSliderMode()) return;

    var index = this.slides.findIndex(function (slide) {
      return slide.dataset.blockId === blockId;
    });

    if (index !== -1) {
      this.show(index, false);
      this.stop();
    }
  };

  BenefitsBarSlider.prototype.destroy = function () {
    this.stop();

    if (this.mobileQuery.removeEventListener) {
      this.mobileQuery.removeEventListener('change', this.handleMediaChange);
      this.reducedMotionQuery.removeEventListener('change', this.handleReducedMotionChange);
    } else {
      this.mobileQuery.removeListener(this.handleMediaChange);
      this.reducedMotionQuery.removeListener(this.handleReducedMotionChange);
    }

    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.root.removeEventListener('touchstart', this.handleTouchStart);
    this.root.removeEventListener('touchend', this.handleTouchEnd);
    this.root.removeEventListener('mouseenter', this.handleMouseEnter);
    this.root.removeEventListener('mouseleave', this.handleMouseLeave);
    this.root.removeEventListener('focusin', this.handleFocusIn);
    this.root.removeEventListener('focusout', this.handleFocusOut);
    delete this.root._benefitsBarSlider;
    delete this.root.dataset.sliderInitialized;
  };

  function init(scope) {
    var roots = [];

    if (scope.matches && scope.matches(ROOT_SELECTOR)) {
      roots.push(scope);
    }

    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll(ROOT_SELECTOR)));

    roots.forEach(function (root) {
      new BenefitsBarSlider(root);
    });
  }

  function initDocument() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDocument);
  } else {
    initDocument();
  }

  if (!window.__lpBenefitsBarEditorEvents) {
    window.__lpBenefitsBarEditorEvents = true;

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector(ROOT_SELECTOR);
      if (root && root._benefitsBarSlider) {
        root._benefitsBarSlider.destroy();
      }
    });

    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest(ROOT_SELECTOR);
      if (root && root._benefitsBarSlider) {
        root._benefitsBarSlider.selectBlock(event.detail.blockId);
      }
    });
  }
})();
